import { DailyVideoRoom } from '@cannect/components/DailyVideoRoom'
import { getDailyRoomUrl, getDailyToken } from '@cannect/services/resources/instantConsultation/requests'
import { AlertCircle } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useInstantConsultation } from 'hooks/useInstantConsultation'

export function VideoCallStep() {
  const { session, callDuration, handleFinishCall, updatePatientConnectionStatus } = useInstantConsultation()
  const [confirmLeave, setConfirmLeave] = useState(false)
  const [leaving, setLeaving] = useState(false)

  const url = session ? (getDailyRoomUrl(session) ?? '') : ''
  const token = session ? (getDailyToken(session) ?? '') : ''

  const handleConnected = async () => {
    await updatePatientConnectionStatus('connected')
  }

  const handleRemoteDisconnected = () => {
    toast.info('O médico encerrou a consulta.')
    setConfirmLeave(false)
    handleFinishCall('patient')
  }

  const handleError = (message: string) => {
    toast.error(message)
  }

  const handleLeaveRequest = () => {
    setConfirmLeave(true)
  }

  const handleConfirmLeave = async () => {
    setLeaving(true)
    try {
      await handleFinishCall('patient')
    } finally {
      setLeaving(false)
      setConfirmLeave(false)
    }
  }

  if (!url || !token) {
    return (
      <div className="flex h-64 flex-col items-center justify-center gap-3 text-gray-500">
        <AlertCircle className="h-10 w-10 text-red-400" />
        <p className="text-sm">Dados da videochamada não disponíveis. Tente novamente.</p>
      </div>
    )
  }

  return (
    <div className="relative h-[calc(100dvh-80px)] w-full overflow-hidden bg-gray-900">
      <DailyVideoRoom
        url={url}
        token={token}
        callDuration={callDuration}
        onLeave={handleLeaveRequest}
        onConnected={handleConnected}
        onRemoteDisconnected={handleRemoteDisconnected}
        onError={handleError}
      />

      {/* Modal de confirmação para encerrar */}
      {confirmLeave && (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/60 backdrop-blur-sm">
          <div className="mx-4 w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
            <h3 className="mb-2 text-lg font-bold text-gray-800">Encerrar consulta?</h3>
            <p className="mb-6 text-sm text-gray-500">
              Tem certeza que deseja encerrar a consulta? Esta ação não pode ser desfeita.
            </p>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => setConfirmLeave(false)}
                disabled={leaving}
                className="flex-1 rounded-lg border-none py-3 text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-60">
                Continuar
              </button>
              <button
                type="button"
                onClick={handleConfirmLeave}
                disabled={leaving}
                className="flex-1 rounded-lg border-none bg-red-600 py-3 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-60">
                {leaving ? 'Encerrando...' : 'Encerrar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
